// extracted by mini-css-extract-plugin
module.exports = {"grid-system":"Grid_grid-system__cz9xx","grid-column-drugManufacturers":"Grid_grid-column-drugManufacturers__Nom0Z"};